module.exports = {
  "$id": "passwordSetting",
  "type": "object",
  "title": "设置密码",
  "properties": {
    "password": {
      "title": "新密码",
      "type": "string",
      "format": "password"
    },
    "confirmPassword": {
      "title": "确认密码",
      "type": "string",
      "format": "password",
      "const": {
        "$data": "1/password"
      }
    }
  },
  "required": [
    "password",
    "confirmPassword"
  ],
  "errorMessage": {
    "password": {
      "message": "请输入6位数字的密码",
      "required": "新密码不能为空"
    },
    "confirmPassword": {
      "message": "两次密码输入不一致！",
      "pattern": "请输入6位数字的密码",
      "required": "请再次输入密码"
    }
  }
}
